import type { ZealApiResponse, ZealApiSuccessResponse } from "@zeal/common";
import { ECompanyType, ECompanyStatus, EClassification } from "@zeal/common";
import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { returnZealApiErrorResponse } from "../../returnZealApiErrorResponse";

const PATH = "/companies";

type GetCompaniesResponseBody = {
  status: ECompanyStatus;
  is_sandbox: boolean;
  business_name: string;
  business_ein: string;
  classification: EClassification;
  company_type: ECompanyType;
  onboarding_url: string;
  companyID: string;
  deposit_account_form?: boolean;
  direct_deposit_form?: boolean;
  electronic_communication_form?: boolean;
  patriot_act_form?: boolean;
  puzzl_terms_conditions?: boolean;
  reporting_agent_form?: boolean;
  tax_information_authorization_form?: boolean;
  company_onboarding_task_fields?: Readonly<Record<string, string>>;
  ssn?: string;
  ownership_percentage?: number;
  legal_structure?: string;
  dob?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}[];

type GetCompaniesRequest = {
  partnerID?: string;
  companyID?: string;
  include_form_statuses?: boolean;
  mode?: string;
};

type GetCompaniesResponse = ZealApiResponse<{ data: GetCompaniesResponseBody }>;

export const getCompanies =
  (axios: IAxiosInstance) =>
  async ({
    partnerID,
    companyID,
    include_form_statuses,
    mode,
  }: GetCompaniesRequest) => {
    try {
      const response = await axios.noRetry.get<GetCompaniesResponse>(PATH, {
        params: {
          partnerID,
          companyID,
          include_form_statuses,
          ...(mode === "test" ? { test: true } : {}),
        },
      });
      return response.data as ZealApiSuccessResponse<{
        data: GetCompaniesResponseBody;
      }>;
    } catch (err) {
      return returnZealApiErrorResponse(err);
    }
  };
